






































































































































































































import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import AbpBase from '../../lib/abpbase'
import PicModal from '@/components/upload/picModal.vue'
import draggable from 'vuedraggable'
import GoodSelect from '@/components/goods-select/index.vue'
import ArticleApi from '@/api/article/index'
import EditorCustomize from '@/components/editorCustomize/index.vue'
@Component({
  components: {
    PicModal,
    draggable,
    GoodSelect,
    EditorCustomize
  }
})
export default class EditArticle extends AbpBase {
  form = {
    title: null,
    description: null,
    categoryId: null,
    labels: [],
    images: [],
    content: null,
    isActive: true,
    guidance: true,
    discovery: true,
    relatedProducts: []
  }

  ruleForm = {
    categoryId: [
      { required: true, message: '请选择文章分类', trigger: 'blur,change' }
    ],
    title: [{ required: true, message: '请输入文章标题', trigger: 'blur' }]
    // labelIds: [
    //   { required: true, validator: this.validateLabels, trigger: 'blur,change' }
    // ]
  }

  validateLabels(rule, value, callback) {
    if (value.length <= 0) {
      callback(new Error('请选择文章标签'))
    } else {
      callback()
    }
  }

  columns: any[] = [
    {
      title: '商品图',
      slot: 'pictureUrl',
      align: 'center'
    },
    {
      title: '商品名称',
      key: 'name',
      align: 'center'
    },
    {
      title: '货号',
      key: 'code',
      align: 'center'
    },
    {
      title: '价格',
      key: 'price',
      align: 'center'
    },
    {
      title: '操作',
      slot: 'action',
      type: 'action',
      width: 150,
      align: 'center'
    }
  ]
  categoryList = []
  labelList = []

  get selectedGoods() {
    let list = []
    if (this.form.relatedProducts) {
      list = this.form.relatedProducts.map(item => {
        return item.productId
      })
    }

    return list
  }

  created() {
    this.getCategoryList()
    this.getLabelList()
    this.getArticleDetail()
  }

  /**
   * 获取文章详情
   */
  getArticleDetail() {
    let id = this.$route.query['id']
    if (id) {
      ArticleApi.getArticleDetail(id.toString()).then(res => {
        if (res.data) {
          if (!res.data.relatedProducts) {
            res.data.relatedProducts = []
          }
          if (res.data.labels && res.data.labels.length > 0) {
            res.data.labelIds = res.data.labels.map(item => {
              return item.id
            })
          } else {
            res.data.labelIds = []
          }
          this.form = res.data
        }
      })
    }
  }

  removeImg(index) {
    this.form.images.splice(index, 1)
  }

  /**
   * 获取所有文章分类
   */
  getCategoryList() {
    ArticleApi.getCategoryList().then(res => {
      this.categoryList = res.data.items
    })
  }

  /**
   * 获取所有文章标签
   */
  getLabelList() {
    ArticleApi.getLabelList().then(res => {
      this.labelList = res.data.items
    })
  }

  picChange(event) {
    let len = 9 - this.form.images.length
    len = len > event.length ? event.length : len
    for (let i = 0; i < len; i++) {
      this.form.images.push(event[i].url)
    }
  }

  editorChange(e) {
    this.form.content = e
  }

  /**
   * 删除所选商品
   */
  deleteProducts(index) {
    this.form.relatedProducts.splice(index, 1)
  }

  /**
   * 选择商品信息
   */
  productsChange(e) {
    if (e) {
      if (!this.form.relatedProducts) {
        this.form.relatedProducts = []
      }
      e.forEach((item, index) => {
        if (
          this.form.relatedProducts &&
          this.form.relatedProducts.indexOf(item.id) == -1 &&
          index < 19 &&
          this.form.relatedProducts.length < 20
        ) {
          let obj = {
            code: item.code,
            name: item.name,
            pictureUrl: item.pictureUrl,
            productId: item.id,
            price: item.price
          }
          this.form.relatedProducts.push(obj)
        }
      })
    }
  }

  submit() {
    let form: any = this.$refs.form
    form.validate(valid => {
      if (valid) {
        if (this.form.images.length == 0) {
          this.$Message.error('请选择文章头图')
          return
        }
        if (!this.form.content) {
          this.$Message.error('请输入文章正文!')
          return
        }

        ArticleApi.createOrUpdateArticle(this.form).then(res => {
          this.$router.push({
            name: 'articleList'
          })
        })
      } else {
        this.$Message.error('请输入必填字段!')
      }
    })
  }
}
